import { BookOpen01 } from "@untitled-ui/icons-react";
import { type TFunction } from "i18next";

export default {
  name: "handbook",
  priority: 6,
  icon: BookOpen01,
  menu: ({ t }: { t: TFunction }) => ({
    admin: [
      {
        label: t("Handbook", { ns: "handbook.shared" }),
        icon: <BookOpen01 className="h-6 w-6" />,
        child: [
          {
            label: t("Handbook", { ns: "handbook.shared" }),
            to: "/admin/handbook/entries",
            permission: "handbook.handbook-entry.view",
          },
          {
            label: t("Categories", { ns: "core.shared" }),
            to: "/admin/handbook/categories",
            permission: "handbook.handbook-entry-category.view",
          },
        ],
      },
    ],
  }),
} satisfies ModuleData;
